<template>
  <v-data-table
    class="narrowTable"
    :headers="headers"
    :items="devices"
    :item-key="'id'"
    :pagination.sync="pagination"
    hide-actions
    must-sort
  >
    <template v-slot:items="props">
      <elac-devices-list-device :device="props.item" />
    </template>
  </v-data-table>
</template>

<script>
import ElacDevicesListDevice from '@/components/ElacDevicesListDevice.vue';
import TenantCurrent from '@/mixins/TenantCurrent';
import { createNamespacedHelpers } from 'vuex';

const mapStateDevices = createNamespacedHelpers('devices').mapState;
const mapStatePreferences = createNamespacedHelpers('preferences').mapState;

export default {
  components: {
    ElacDevicesListDevice,
  },

  mixins: [TenantCurrent],

  data: () => ({
    headers: [
      { text: 'Label', align: 'left', value: 'label' },
      { text: 'Nom', value: 'display_name' },
      { text: 'Couleur', value: 'color' },
      { text: 'Délai', value: 'heartbeat' },
      { text: 'Bat', value: 'battery' },
      { text: 'Actions', value: 'id', sortable: false },
    ],

    pagination: {
      sortBy: 'name',
      descending: false,
      rowsPerPage: -1,
    },
  }),

  computed: {
    ...mapStateDevices([
      'devices',
    ]),

    ...mapStatePreferences({
      preferences: state => state.preferences,
    }),
  },

  beforeMount() {
    this.$store.dispatch('devices/fetchList', {
      tenantId: this.tenant.id,
    });
  },
};
</script>

<style>
.narrowTable thead tr:first-child {
  height: 35px !important;
}

.narrowTable thead tr:first-child th {
  padding: 0 10px !important;
}

.narrowTable tbody td {
  height: 30px !important;
  padding: 0 10px !important;
}

.narrowTable td, .narrowTable td {
  padding: 10px;
}
</style>
